import { CommitmentClassTabProps } from "features/commitment-classes/setup/CommitmentClassTabProps";
import { CommitmentsTable } from "features/commitments/CommitmentsTable";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const CommitmentClassTabCommitments: React.FC = () => {
  const { fundFamilyId, investorClassId } =
    useOutletContext<CommitmentClassTabProps>();
  return (
    <PageTabBody>
      <CommitmentsTable
        isFullWidth={true}
        fundFamilyId={fundFamilyId}
        params={{
          investor_class_id: investorClassId,
        }}
      />
    </PageTabBody>
  );
};
